import { render, staticRenderFns } from "./moreContentX.vue?vue&type=template&id=249bb4d1&lang=pug&"
import script from "./moreContentX.vue?vue&type=script&lang=js&"
export * from "./moreContentX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports